import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [],
    state: {
        config: {
            baseUrl: "",
        },
        searchApp: {
            state: {
                hasSearched: false,
                loading: false,
            },
            search: {
                selectedGroup: "All",
                sort: "",
                searchText: "",
                start: 0,
            },
            searchOptions: {
                groupPages: [],
            },
            lastSearchedFor: {
                selectedGroup: "",
                sort: "",
                searchText: "",
            },
            searchResult: {
                totalResults: 0,
                currentPage: 0,
                totalPages: 0,
                nextStart: null,
                prevStart: null,
                results: [],
            },
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
    },
    actions: {

        async submitSearch({ state, commit }) {

            // debugger;
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);

            const paramNames = ["selectedGroup", "sort", "searchText", "start"];

            // set params from search state
            for (const paramName of paramNames) {
                params.set(paramName, state.searchApp.search[paramName]);
            }

            //todo make sure to parse quotes and other special characters
            url.search = params.toString();
            let newUrl = url.toString();
            window.history.pushState({ path: newUrl }, "", newUrl);

            commit("updateField", {
                path: "searchApp.state.loading",
                value: true,
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor.selectedGroup",
                value: state.searchApp.search.selectedGroup,
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor.sort",
                value: state.searchApp.search.sort,
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor.searchText",
                value: state.searchApp.search.searchText,
            });

            const currentUrl = window.location.origin + window.location.pathname.replace(/\/$/, "");
            let searchUrl = `${currentUrl}/searchanzcor`; 
            
            if (currentUrl.includes("localhost")) {
                searchUrl += `?SubsiteID=1`;
            }

            return await axios
                .post(searchUrl, state.searchApp.search)
                .then((response) => {
                    console.log(response);
                    if (response.data) {
                        commit("updateField", {
                            path: "searchApp.searchResult",
                            value: response.data,
                        });
                    }

                    commit("updateField", {
                        path: "searchApp.state.loading",
                        value: false,
                    });
                    commit("updateField", {
                        path: "searchApp.state.hasSearched",
                        value: true,
                    });
                })
                .catch((error) => {
                    console.log(error);
                    commit("updateField", {
                        path: "searchApp.state.loading",
                        value: false,
                    });
                    commit("updateField", {
                        path: "searchApp.state.hasSearched",
                        value: true,
                    });
                });
        },
        resetSearch({ commit }) {
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete("selectedGroup");
            currentUrl.searchParams.delete("sort");
            currentUrl.searchParams.delete("searchText");
            currentUrl.searchParams.delete("start");
            window.history.replaceState({}, '', currentUrl.toString()); 

            commit("updateField", {
                path: "searchApp.state.loading",
                value: false,
            });

            commit("updateField", {
                path: "searchApp.search",
                value: {
                    selectedGroup: "All",
                    sort: "",
                    searchText: "",
                    start: 0,
                },
            });

            commit("updateField", {
                path: "searchApp.lastSearchedFor",
                value: {
                    selectedGroup: "",
                    sort: "",
                    searchText: "",
                },
            });

            commit("updateField", {
                path: "searchApp.searchResult",
                value: {
                    totalResults: 0,
                    currentPage: 0,
                    totalPages: 0,
                    nextStart: null,
                    prevStart: null,
                    results: [],
                },
            });
        }
    },
});